module.exports = __webpack_public_path__ + "static/img/11.ba4c4fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/11.png
// module id = WhMi
// module chunks = 0